import Accordion from '../../common/Collapsible'
import React from 'react'
import { MarkdownContent } from '../../Content/Content'
import styles from './FaqBlock.module.scss'
import { Script } from 'gatsby'
export interface Faq {
  question: string
  answer: string
}

export interface FAQBlocksProps {
  faqBlocks: Faq[]
  markdown?: boolean
}

export function FAQBlock({ faqBlocks, markdown = false }: FAQBlocksProps) {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqBlocks.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  }

  return (
    <div className={styles.faqSection}>
      <Script id='faq-schema' type='application/ld+json'>
        {JSON.stringify(faqSchema)}
      </Script>
      <h3 className={styles.title}>FAQ</h3>
      <Accordion
        plusIcon
        blogVariant
        sections={faqBlocks.map((entry) => ({
          title: entry.question,
          content: Content(entry.answer, markdown),
        }))}
      />
    </div>
  )
}

function Content(content: string, markdown: boolean) {
  return markdown ? (
    <MarkdownContent markdown={content} className={styles.content} useBlogStyles={false} />
  ) : (
    <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
  )
}
